import { RouterV3Enum } from '@/router/router-names';
import type { RouteConfig } from 'vue-router';
import { TP_HOME_PAGE_ID } from './tianqi';

const HOME_V3_ROUTE_CONFIG: RouteConfig = {
  name: RouterV3Enum.home,
  path: `${RouterV3Enum.home}`,
  component: () => import(/* webpackChunkName: "home_v3" */'./index.vue'),
  meta: {
    title: '',
    needLogin: true,
    pageId: TP_HOME_PAGE_ID,
    isShowH5Nav: true,
    isControlCoffeeH5Nav: true,
    /** 新版首页开启keepAlive */
    keepAlive: true,
  },
};

export default HOME_V3_ROUTE_CONFIG;
